import React from 'react';
import '../css/Pagination.css'; // Add the CSS provided earlier here.

const Pagination = ({ currentPage, totalPages, onPageChange, totalListings }) => {
    const startIndex = (currentPage - 1) * 12 + 1;
    const endIndex = Math.min(currentPage * 12, totalListings);

    return (
        <div className="pagination">
            <span className="pagination-summary">
                {startIndex} - {endIndex} of {totalListings} listings
            </span>
            <button
                disabled={currentPage === 1}
                onClick={() => onPageChange(currentPage - 1)}
            >
                &lt; Previous
            </button>
            {Array.from({ length: totalPages }, (_, index) => (
                <button
                    key={index + 1}
                    className={currentPage === index + 1 ? 'active' : ''}
                    onClick={() => onPageChange(index + 1)}
                >
                    {index + 1}
                </button>
            ))}
            <button
                disabled={currentPage === totalPages}
                onClick={() => onPageChange(currentPage + 1)}
            >
                Next &gt;
            </button>
        </div>
    );
};

export default Pagination;
